import * as THREE from 'three';

export function combineGeometries(...geometries) {
  const g = new THREE.Geometry();
  for (const geometry of geometries) {
    const vertexIndexStart = g.vertices.length;
    const faceIndexStart = g.faces.length;
    for (const v of geometry.vertices) {
      g.vertices.push(v);
    }
    for (const f of geometry.faces) {
      g.faces.push(f);
    }
    for (let i = faceIndexStart; i < g.faces.length; i++) {
      g.faces[i].a += vertexIndexStart;
      g.faces[i].b += vertexIndexStart;
      g.faces[i].c += vertexIndexStart;
    }
  }
  return g;
}

export function createPartialCircleGeometry(
  innerRadius,
  outerRadius,
  segments,
  angleStart,
  angleLength
) {
  const angleStep = angleLength / (segments - 1);

  const g = new THREE.Geometry();
  for (let i = 0; i < segments; i++) {
    const x = Math.cos(angleStart + angleStep * i);
    const y = Math.sin(angleStart + angleStep * i);
    g.vertices.push(new THREE.Vector3(x * innerRadius, y * innerRadius, 0));
    g.vertices.push(new THREE.Vector3(x * outerRadius, y * outerRadius, 0));
  }
  for (let i = 0; i < segments - 1; i++) {
    const si = i * 2;
    g.faces.push(new THREE.Face3(si + 0, si + 1, si + 2));
    g.faces.push(new THREE.Face3(si + 1, si + 3, si + 2));
  }
  return g;
}
